import * as Yup from 'yup';

// The calibration inputs unmount when the toggle is off, so a rule that fired
// anyway would block submit on an error with no field on screen to show it.
const whenCalibrationEnabled = (rules: Yup.NumberSchema<any>) =>
  Yup.mixed().when('hasCalibrationVideos', {
    is: true,
    then: rules,
    otherwise: Yup.mixed().notRequired(),
  });

// A cleared number input casts to NaN, whose default message quotes the cast.
const calibrationCount = Yup.number()
  .typeError('Enter a whole number')
  .integer('Use a whole number')
  .min(1, 'Must be at least 1');

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Company name is required'),
  timezone: Yup.string().required('Select your timezone'),
  companyWebsite: Yup.string().required('Provide your company website'),
  communicationEmail: Yup.string().required('Email communication is required'),
  evaluationGroupName: Yup.string().nullable(),
  introLink: Yup.string().nullable(),
  isAttendanceRequestedDefault: Yup.boolean(),
  reportCardsIncludeNonConcludedDefault: Yup.boolean(),
  retainJerseyAssignments: Yup.boolean(),
  hasCalibrationVideos: Yup.boolean(),
  maxCalibrationSkillsPerAssignment: whenCalibrationEnabled(
    calibrationCount
      // A second .min(Yup.ref(...)) would replace the .min(1) test (Yup's min
      // is exclusive), so enforce the cross-field floor via a named test.
      .test(
        'gte-min-per-assignment',
        'Cannot be less than the per-assignment minimum',
        function (value) {
          const min = this.parent.minCalibrationSkillsPerAssignment;
          return value == null || min == null || value >= min;
        },
      )
      .required('Required'),
  ),
  minCalibrationSkillsPerAssignment: whenCalibrationEnabled(
    calibrationCount
      .max(Yup.ref('maxCalibrationSkillsPerAssignment'), 'Cannot exceed the per-assignment maximum')
      .required('Required'),
  ),
  maxCalibrationSkillsPerVideoPerAssignment: whenCalibrationEnabled(
    calibrationCount
      .max(Yup.ref('maxCalibrationSkillsPerAssignment'), 'Cannot exceed the per-assignment maximum')
      .required('Required'),
  ),
  periodLengthDays: whenCalibrationEnabled(calibrationCount.required('Required')),
  maxCalibrationSkillsPerPeriod: whenCalibrationEnabled(calibrationCount.required('Required')),
  deliveryWindowHours: whenCalibrationEnabled(calibrationCount.required('Required')),
  assignmentCooldownHours: whenCalibrationEnabled(calibrationCount.required('Required')),
  assignmentDueDays: whenCalibrationEnabled(calibrationCount.required('Required')),
});
